<template>
    <div class="meal_update">
        <div class="card">
            <span class="rules" @click="goRules">规则</span>
            <div class="tit">- 升级会员畅学好内容 -</div>
            <div class="subtit">（包含超级会员和同步练会员权益，再享以下特权）</div>
            <div class="items">
                <div v-for="item in cardDate" class="item" :key="item.name">
                    <span>{{ item.num[0] }}<i class="text">{{ item.num[1] }}</i></span>
                    <span>{{ item.name }}</span>
                </div>
            </div>
        </div>
        <div class="paychannel" v-if="source === 'and'">
            <div class="tit">请选择支付方式</div>
            <div class="channel-item">
                <span class="name">微信支付</span>
                <span class="checked"></span>
            </div>
        </div>
        <div class="text">开通包月会员后，<span>免费赠{{ Info.freeDays }}天畅学，</span>可随时取消</div>
        <div class="button" @click="goPay">{{ parseInt(Info.memberProductList[0].discountPrice) }}元包月会员&nbsp;&nbsp;立即升级</div>
    </div>
</template>

<script>
    import { MOBILE_API } from "@/constants/api";
    import utils from "@/assets/js/utils";
    const token = utils.getQueryString('token');
    const version = utils.getQueryString('version');
    const source = utils.getQueryString('source');
    const categoryId = utils.getQueryString('categoryId');
    const pageChannelId = utils.getQueryString('pageChannelId');
    const productId = utils.getQueryString('productId');    //商品Id
    
    export default {
        data() {
            return {
                currentProductId: '',
                cardDate: [
                    {
                        name: '同步练',
                        num: ['3', '科']
                    },
                    {
                        name: '优质音频课',
                        num: ['300+']
                    },
                    {
                        name: '有趣轻课',
                        num: ['300+']
                    },
                    {
                        name: '有声绘本',
                        num: ['300+']
                    },
                    {
                        name: '会员时长',
                        num: [this.Info.freeDays, '天']
                    }
                ],
                isPureSign: 0
            }
        },
        props: {
            Info: {
                type: Object
            },
            source: {   // and；ios
                type: String
            }      
        },
        watch: {
            Info() {
                
            }
        },
        mounted() {
            this.currentProduct = this.Info.memberProductList[0];
            this.currentProductId = this.Info.memberProductList[0].productId;
            this.isPureSign = this.Info.memberProductList[0].isPureSign || 0;
        },
        methods: {
            goRules() {
                let {
                    superMember,
                    syncTest,
                    freeDays
                } = this.Info;
                
                let url = window.location.href.split('?')[0];
                let path = this.source === 'ios' ? url.split("member_ios").join('upgrade_rule_ios') : url.split("member_and").join('upgrade_rule_and');

                    path = path + `?superMember=${superMember}&syncTest=${syncTest}&freeDays=${freeDays}`
                    url = encodeURIComponent(path);

                window.location.href = "hybird://method/openNewWindow?url=" + url;
            },
            goPay(from) {
                if(from !== 'cancelPop') {
                    gio('track', 'vipUpdatePage_update_click', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx913')
                    
                }
                

                // let comeFrom = this.Info.needUpgrade ? '113' : '112';
                let comeFrom = '112';
                let url = this.source === 'ios' ?
                        `hybird://method/openDirectPay?productId=${this.currentProductId}&jsCallBack=failToast`:
                        `hybird://method/${this.isPureSign == 1?'openFreeDirectPay':'openDirectPay'}?productId=${this.currentProductId}&jsCallBack=jsCallback&productName=${this.currentProduct.title}&comeFrom=${comeFrom}&paymentChannel=wx`;
                setTimeout(()=>{
                    window.location.href = url;
                },100)
                 
            },
            typePriceMap(productType) {
                let discountPrice;
                this.Info.memberProductList.some((item, index)=>{
                    if(item.productType === productType) {
                        discountPrice = productType === 24 ? item.originPrice :item.discountPrice;
                        return true;
                    }
                    
                })
                return discountPrice;
            },
            getGioParams(){
                return {
                    categoryId,
                    pageChannelId,
                    isVip: this.Info.memberInfo.isMember,
                    productId,
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @font-face{
        font-family: "BebasNeueBold";
        src: url('https://appd.knowbox.cn/ss/v310/BebasNeueBold.ttf');
    }
    .meal_update {
        background: #ffffff;
        overflow: hidden;
        position: relative;
        margin-top: -.44rem;
        border-radius: .44rem .44rem 0 0;
        box-shadow: 0px -6px 12px 0px 
		rgba(144, 117, 67, 0.1);
    .card {
        width: 6.88rem;
        height: 3rem;
        background-color: #fefaee;
        border: .03rem solid #dd993e;
        border-radius: .14rem;
        margin: .48rem auto .28rem;
        position: relative;
        .rules {
            position: absolute;
            font-size: .22rem;
            color: #825416;
            right: .1rem;
            top: .1rem;
            display: flex;
            align-items: center;
            &::after {
                content: '';
                display: inline-block;
                width: .24rem;
                height: .24rem;
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_rule.png) 0 0 no-repeat;
                background-size: 100%;
                margin-left: .05rem;
            }
        }
        .tit {
            font-family: PingFangSC-Semibold;
            font-weight: bold;
            font-size: .32rem;
            color: #7b531e;
            margin-top: .51rem;
        }
        .subtit {
            font-size: .20rem;
	        color: #e1c8a5;
        }
        .items {
            display: flex;
            padding: 0 .4rem;
            box-sizing: border-box;
            justify-content: space-between;
            margin-top: .34rem;
            .item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                span:first-of-type {
                    font-family: BebasNeueBold;
                    font-size: .5rem;
                    color: #7b531e;
                    .text {
                        font-family: PingFangSC-Semibold;
                        font-weight: bold;
                        font-size: .24rem;
                        color: #7b531e;
                    }
                }
                span:last-of-type {
                    font-family: PingFangSC-Medium;
	                font-size: .22rem;
	                color: #e08a17;
                }
            }
        }
    }
    .text {
        height: .3rem;
        line-height: .3rem;
        font-size: .22rem;
        color: #919294;
        text-align: left;
        text-indent: .4rem;
        margin-top: .44rem;
        span {
            color: #e08a17;
        }
    }
    .paychannel {
        padding: 0 .6rem 0 .4rem;
        box-sizing: border-box;
        // border-top: solid #f5f5f5 .2rem;
        margin-top: .36rem;
        .tit {
            font-family: PingFangSC-Medium;
            font-size: .28rem;
            color: #7b531e;
            text-align: left;
            // text-indent: .4rem;
            height: .84rem;
            line-height: 1rem;
        }
        .channel-item {
            height: 1rem;
            line-height: 1rem;
            font-size: .24rem;
            color: #919294;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
                display: flex;
                align-items: center;
                &::before {
                    content: '';
                    display: inline-block;
                    width: .44rem;
                    height: .44rem;
                    background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/paystyle_icon_wechat.png) 0 0 no-repeat;
                    background-size: 100%;
                    margin-right: .2rem;
                }
            }
            .checked {
                display: inline-block;
                width: .4rem;
                height: .4rem;
                background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/selected.png) 0 0 no-repeat;
                background-size: 100%;
            }
        }

    }
    .button {
        width: 6.62rem;
        height: .82rem;
        // line-height: .76rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/button_kaitong.png) 0 0 no-repeat;
        background-size: 100%;
        border-radius: .44rem;
        font-family: PingFangSC-Semibold;
        font-weight: bold;
        font-size: .34rem;
        color: #fff;
        margin: .35rem auto 0 auto;
    }
}
</style>